import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ReportTagsTable from "components/recoveries/report-tags/report-tags-table"
// Data
import api_match from "data/interface/api"
import reportTagService from "data/report-tag"
import propertyService from 'data/property'
import { alphanum } from "components/table/lib/sort"
//Styles
import { ReportTags_s } from "components/recoveries/report-tags/report-tags-styles"
import { AddIcon } from "images/icons/tools"
import rentrollService from 'data/rent-roll'

const ReportTags: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "report-tags-table"

  useEffect(() => {

    const reportTagSubscription = reportTagService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        setProperty(currentProperty)
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      reportTagSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    reportTagService.fetchReportTags(propertyId);
    propertyService.fetchProperty(propertyId);
    rentrollService.fetchRentRoll(propertyId, false);

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => reportTagService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <ReportTags_s>
      <Toolbar>
        <Add />
      </Toolbar>
      { data && property && <ReportTagsTable tableId={tableId} data={data} property={property} /> }
    </ReportTags_s>
  )
}

export default ReportTags
